import React from 'react';
import { useTranslation } from 'react-i18next';
import Masonry from 'react-masonry-css';
import ProductBlock from 'shared/components/likiee/ProductBlock';

const SearchLikiees = ({ items, showAllTabs }) => {
  const { t } = useTranslation();

  if (!items?.length) {
    if (!showAllTabs) {
      return <p className='text-center'>{t('likiees_no_result')}</p>;
    } else {
      return null;
    }
  }

  return (
    <div className='mb-20'>
      <h2 className='mb-10'>{t('title_likiees')}</h2>
      <Masonry
        breakpointCols={{
          default: 4,
          1100: 3,
          500: 2,
        }}
        className='recomended-items-grid pl-6 pl-md-0'
        columnClassName='recomended-items-grid-column'
      >
        {items?.map((item, i) => {
          return (
            <ProductBlock
              product={item}
              key={i}
              showAlarm={true}
              showDate={true}
              notAvailable={item.availability === 'OutOfStock'}
            />
          );
        })}
      </Masonry>
    </div>
  );
};

export default SearchLikiees;
